import { createActionGroup, emptyProps, props } from '@ngrx/store';
import { ProductTreeActionsItem } from 'src/app/core/models/productTreeActions.model';
import type { EntitiesPaged } from '../../../core/models/entities-paged.model';

export const ProjectEntityListActions = createActionGroup({
  source: 'Project entity list',
  events: {
    query_entity_list_start: emptyProps(),
    query_entity_list_success: props<{ projectList: EntitiesPaged; rootActions: ProductTreeActionsItem[] }>(),
    query_entity_list_fail: props<{ error: any }>(),

    delete_entity_start: props<{ entityIdList: string[] }>(),
    delete_entity_success: emptyProps(),
    delete_entity_fail: props<{ error: any }>(),

    change_filter: props<{ searchPhrase: string; onlyMine: boolean }>(),
    change_paging: props<{ page: number; pageSize: number }>(),

    copy_entity_start: props<{ id: string }>(),
    copy_entity_success: emptyProps(),
    copy_entity_fail: props<{ error: any }>(),

    import_xml_start: props<{ file: File }>(),
    import_xml_success: emptyProps(),
    import_xml_fail: props<{ error: any }>(),

    search: emptyProps()
  }
});
